import { render, staticRenderFns } from "./PayoutMethodBanner.vue?vue&type=template&id=6924e303&scoped=true&"
import script from "./PayoutMethodBanner.vue?vue&type=script&lang=js&"
export * from "./PayoutMethodBanner.vue?vue&type=script&lang=js&"
import style0 from "./PayoutMethodBanner.vue?vue&type=style&index=0&id=6924e303&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6924e303",
  null
  
)

export default component.exports